<template>
  <div class="price">
    <div
      v-if="pricePercentReduction"
      class="price-reduction"
    >
      <del>
        <span>
          {{ formatCurrency(roundedOriginal, undefined, undefined, noDecimals ? {
            minimumFractionDigits: 0
          } : {}) }}
        </span>
      </del>
      <span
        v-if="pricePercentReduction"
        class="badge-price-reduction"
      >
        - {{ pricePercentReduction }}%
      </span>
    </div>
    <template v-if="showOff">
      {{ $t('object:vacancy.price.perWeekPrepend') }}
    </template>
    <em>
      <span>
        {{ formatCurrency(roundedPrice, undefined, undefined, noDecimals ? {
          minimumFractionDigits: 0
        } : {}) }}
      </span>
    </em>
  </div>
</template>
<script>
import getNumberFormat from 'mixins/composition/NumberFormat';

export default {
  name: 'ObjectPriceOriginal',
  props: {
    price: {
      type: Number,
      default: 0,
    },
    original: {
      type: Number,
      required: false,
      default: 0,
    },
    currency: {
      type: String,
      required: true,
    },
    priceComplete: {
      type: Number,
      required: false,
      default: 0,
    },
    pricePercentReduction: {
      type: Number,
      required: false,
      default: 0,
    },
    showOff: {
      type: Boolean,
      default: false,
    },
    noDecimals: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  setup(_, ctx) {
    const { formatCurrency } = getNumberFormat(ctx);
    return { formatCurrency };
  },
  data() {
    return {

    };
  },
  computed: {
    currentPrice() {
      return this.priceComplete > 0 ? this.priceComplete : this.price;
    },
    roundedOriginal() {
      return this.noDecimals ? Math.ceil(this.original) : this.original;
    },
    roundedPrice() {
      return this.noDecimals ? Math.ceil(this.currentPrice) : this.currentPrice;
    },
  },
  i18nOptions: { namespaces: ['object', 'common'] },

};
</script>

<style lang="scss" scoped>
.price-reduction {
  display: flex;
  justify-content: flex-end;

  .badge-price-reduction {
    color: #fff;

    @include font_size_xs;

    padding: 0.14em 0.35em 0.2em;
    line-height: 1.1em;
    text-align: center;
    min-width: 1.5em;
    background: var(--color_ci);

    @include radius(5px);

    display: inline-block;
    margin-left: 0.5em;
  }
}
</style>
